const { debounce } = window.BAO.Utils;

class CartItem extends window.BAO.CustomElement() {
  static get requiredElements() {
    return ["remove"];
  }

  constructor() {
    super();

    this._loading = false;
    this.sections = this.inPushCart
      ? window.BAO.sectionRenderer.pushCartSections
      : this.onCartPage
        ? window.BAO.sectionRenderer.cartSections
        : [];
  }

  setupListeners() {
    super.setupListeners();

    this.removeLineItem = this.removeLineItem.bind(this);
    this.onQuantityChange = this.onQuantityChange.bind(this);
    this.debouncedOnQuantityChange = debounce((event) => {
      this.onQuantityChange(event);
    }, 500);

    if (this.els?.remove.exists) {
      this.listeners.add(this.els.remove.element, "click", this.removeLineItem);
    }

    this.listeners.add(
      this,
      window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE,
      this.debouncedOnQuantityChange,
    );
  }

  /**
   * @param {MouseEvent} e
   *
   * @returns {void}
   */
  async removeLineItem(e) {
    e.preventDefault();

    this.loading = true;

    const state = await window.BAO.Cart.removeItem(this.dataset.key, {
      sections: this.mappedSections,
    });

    this.loading = false;

    if ("sections" in state) this.renderSections(state.sections);
  }

  async onQuantityChange(e) {
    this.loading = true;

    const quantity = e.detail.value;

    const state = await window.BAO.Cart.updateQuantity(
      this.dataset.key,
      quantity,
      { sections: this.mappedSections },
    );

    this.loading = false;

    if (typeof state === "undefined") {
      const quantityAdjuster = this.querySelector("quantity-adjuster");

      if (quantityAdjuster) {
        quantityAdjuster.value = e.detail.oldValue;
      }

      this.handleError();
    }

    if ("sections" in state) {
      this.renderSections(state.sections);
    }
  }

  handleError() {}

  get mappedSections() {
    return this.sections.map((s) => s.section);
  }

  get loading() {
    return this._loading;
  }

  set loading(val) {
    this._loading = val;

    if (this.inPushCart) {
      this.pushCart.loading = val;
    }

    this.setAttribute("aria-busy", val.toString());
  }

  get pushCart() {
    return this.closest("push-cart");
  }

  get inPushCart() {
    return this.pushCart != null;
  }

  get cart() {
    return this.closest('[data-section-type="template-cart-items"]');
  }

  get onCartPage() {
    return this.cart != null;
  }
}

if (!customElements.get("cart-item")) {
  customElements.define("cart-item", CartItem);
}
